import script from "./ModalResponsable.vue?vue&type=script&setup=true&lang=js"
export * from "./ModalResponsable.vue?vue&type=script&setup=true&lang=js"

import "./ModalResponsable.vue?vue&type=style&index=0&id=17d21b94&scoped=true&lang=css"

import exportComponent from "/home/runner/work/Smart2Docs_Front-end/Smart2Docs_Front-end/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-17d21b94"]])

export default __exports__